import React, { createContext, useContext, useEffect, useState } from "react";
import { apiV1 } from "../../src/api.js";
import { enablePush } from "../push.js";
import { toast } from "sonner";
const AuthContext = createContext(null);
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!localStorage.getItem("queme_token")) return setLoading(false);
    apiV1("/auth/me")
      .then((r) => setUser(r.user))
      .catch(() => localStorage.removeItem("queme_token"))
      .finally(() => setLoading(false));
  }, []);
  useEffect(() => {
    if (!user || !("Notification" in window)) return undefined;
    const timer = window.setTimeout(() => {
      if (Notification.permission === "denied") return;
      enablePush().catch(() => {});
    }, 1200);
    return () => window.clearTimeout(timer);
  }, [user]);
  const login = async (email, password) => {
    const r = await apiV1("/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
    localStorage.setItem("queme_token", r.token);
    if (r.refreshToken)
      localStorage.setItem("queme_refresh_token", r.refreshToken);
    if (r.sessionId)
      localStorage.setItem("queme_session_id", String(r.sessionId));
    setUser(r.user);
    toast.success("Welcome back.");
    return r.user;
  };
  const signup = async (payload) => {
    const r = await apiV1("/auth/signup", {
      method: "POST",
      body: JSON.stringify(payload),
    });
    localStorage.setItem("queme_token", r.token);
    if (r.refreshToken)
      localStorage.setItem("queme_refresh_token", r.refreshToken);
    if (r.sessionId)
      localStorage.setItem("queme_session_id", String(r.sessionId));
    setUser(r.user);
    toast.success("Account created successfully.");
    return r.user;
  };
  const googleLogin = async (credential) => {
    const r = await apiV1("/auth/google", {
      method: "POST",
      body: JSON.stringify({ credential }),
    });
    localStorage.setItem("queme_token", r.token);
    if (r.refreshToken) localStorage.setItem("queme_refresh_token", r.refreshToken);
    if (r.sessionId) localStorage.setItem("queme_session_id", String(r.sessionId));
    setUser(r.user);
    toast.success("Signed in with Google.");
    return r.user;
  };
  const logout = async () => {
    try {
      await apiV1("/auth/logout", {
        method: "POST",
        body: JSON.stringify({
          sessionId: localStorage.getItem("queme_session_id"),
        }),
      });
    } catch (_) {
      /* local logout still succeeds */
    }
    localStorage.removeItem("queme_token");
    localStorage.removeItem("queme_refresh_token");
    localStorage.removeItem("queme_session_id");
    setUser(null);
    toast.success("Signed out.");
  };
  return (
    <AuthContext.Provider value={{ user, loading, login, signup, googleLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
export const useAuth = () => useContext(AuthContext);
